import { loginRetailerUrl } from '@/constants/environment';

export const BUYER_LINK = `${loginRetailerUrl}/?source=shopify&shoppath=%2F`;
export const NEW_SELLER_FORM_LINK = `https://forms.gle/Ha2sp2R53zKPADF49`;
